module.exports = __webpack_public_path__ + "img/pic_casino_popup_waiting@3x.4c62901e.png";